// vendor
import "bootstrap";
import "bootstrap/js/dist/collapse"
import objectFitImages from "object-fit-images";

// moduless
import "./module/fontawesome";
import "./module/header_menu";
import "./module/splide";
import "./module/fixed_below";

// sass
import "../scss/style.scss";

// object-fit for IE
objectFitImages();

// sample
// import "./module/sample_image";

//外部でもjqueryを使えるようにする
window.$ = $